export enum AlertType {
    Success = 'success',
    Danger = 'danger',
    Warning = 'warning',
    Info = 'info'
  }
  